import { render, staticRenderFns } from "./uploag_img.vue?vue&type=template&id=7063e4ed&scoped=true"
import script from "./uploag_img.vue?vue&type=script&lang=js"
export * from "./uploag_img.vue?vue&type=script&lang=js"
import style0 from "./uploag_img.vue?vue&type=style&index=0&id=7063e4ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7063e4ed",
  null
  
)

export default component.exports